(function() {
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("9744Q", function(module, exports) {
    if (customElements.get("image-block")) return;
    class ImageBlock extends HTMLElement {
      constructor() {
        super();
        this._toggle = this.querySelector("[data-read-more-toggle]");
        this._overlay = this.querySelector(".image-block__overlay");
        this._secondary = this.querySelector(".image-block__secondary-content");
        this._textWrapper = this.querySelector(".image-block__text-wrapper");
        this._cta = this._secondary?.querySelector("a");
        this._observer = null;
      }
      connectedCallback() {
        const isOverlaid = this.classList.contains("image-block--overlaid");
        if (!isOverlaid) return;
        if (this._toggle) this._toggle.addEventListener("click", e => {
          e.preventDefault();
          this.toggleExpand();
        });
        this.setupAutoExpand();
      }
      disconnectedCallback() {
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        if (this._toggle && this._onToggleClick) this._toggle.removeEventListener("click", this._onToggleClick);
        if (this._onMouseEnter) this.removeEventListener("mouseenter", this._onMouseEnter);
        if (this._onMouseLeave) this.removeEventListener("mouseleave", this._onMouseLeave);
      }
      toggleExpand(forceState = null) {
        const isExpanded = forceState !== null ? forceState : this.classList.toggle("is-expanded");
        if (forceState !== null) this.classList.toggle("is-expanded", forceState);
        if (this._overlay) this._overlay.classList.toggle("mobile-active", isExpanded);
        if (this._textWrapper) {
          if (isExpanded) this._textWrapper.style.maxHeight = this._textWrapper.scrollHeight + "px"; else this._textWrapper.style.maxHeight = "0px";
        }
        if (this._cta && window.matchMedia("(max-width: 1024px)").matches) {
          if (isExpanded) this._cta.classList.add("opacity-100", "translate-y-0", "pointer-events-auto"); else this._cta.classList.remove("opacity-100", "translate-y-0", "pointer-events-auto");
        }
        if (this._toggle) {
          const readMore = this._toggle.dataset.readMore || window.MBF?.strings?.readMore;
          const readLess = this._toggle.dataset.readLess || window.MBF?.strings?.readLess;
          if (readMore && readLess) this._toggle.textContent = isExpanded ? readLess : readMore;
          this._toggle.setAttribute("aria-expanded", isExpanded);
        }
      }
      setupAutoExpand() {
        const carousel = this.closest("[data-carousel]") || this.closest(".overflow-x-auto");
        if (!carousel) return;
        if (!this._secondary && !this._overlay) return;
        const isDesktop = window.matchMedia("(min-width: 1025px)").matches;
        if (isDesktop) {
          this._onMouseEnter = () => {
            this.toggleExpand(true);
            carousel.querySelectorAll("image-block").forEach(el => {
              if (el !== this) el.toggleExpand(false);
            });
          };
          this._onMouseLeave = () => {
            this.toggleExpand(false);
          };
          this.addEventListener("mouseenter", this._onMouseEnter);
          this.addEventListener("mouseleave", this._onMouseLeave);
          return;
        } else {
          const allBlocks = Array.from(carousel.querySelectorAll("image-block"));
          if (allBlocks.indexOf(this) === 0) this.toggleExpand(true);
          const options = {
            root: carousel,
            threshold: .6,
            rootMargin: "0px -25% 0px -25%"
          };
          this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.toggleExpand(true);
                allBlocks.forEach(el => {
                  if (el !== this && typeof el.toggleExpand === "function") el.toggleExpand(false);
                });
              }
            });
          }, options);
          this._observer.observe(this);
        }
      }
    }
    customElements.define("image-block", ImageBlock);
  });
  parcelRequire("9744Q");
})();